export default function ErrorFormik({ isTouched, isError, error }) {
    return (
      <>
        {isError && isTouched ? (
          <div
            className={`text-[#FF0000] text-xs font-medium leading-normal mt-[10px]`}
          >
            {error}
          </div>
        ) : null}
      </>
    );
  }
  